export const getStyled = () => ({
  grid: {
    height: 'calc(100% - 48px)',
    display: 'grid',
    gridTemplateRows: '56px 1fr',
  },
  content: {
    overflow: 'auto',
  },
  placeholderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
});
